// Toggle for the notification hub mock mode. Lets the bell, dropdown, and screen
// render sample data without real InboxItem rows in the database.
//
// Enable via any of:
//   - build env: VITE_MOCK_NOTIFICATIONS="true"
//   - runtime:   localStorage.setItem("pawseum:mockNotifications", "true")
//   - dev URL:   ?mockNotifications=1  (persists the flag; use =0 to turn off)
//
// Kept in its own module so pure/testable modules (mockStore) never import
// import.meta.env.

const STORAGE_KEY = "pawseum:mockNotifications";

// Dev convenience: ?mockNotifications=1 (or =0) flips the persistent flag so you
// can toggle mock data from the address bar without opening the console. Runs
// once at import time and only in dev builds.
function applyUrlOverride(): void {
  if (!import.meta.env.DEV || typeof window === "undefined") return;
  try {
    const value = new URLSearchParams(window.location.search).get(
      "mockNotifications",
    );
    if (value === "1" || value === "true") {
      localStorage.setItem(STORAGE_KEY, "true");
    } else if (value === "0" || value === "false") {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore (SSR / storage blocked)
  }
}

applyUrlOverride();

export function isMockNotificationsEnabled(): boolean {
  if (import.meta.env.VITE_MOCK_NOTIFICATIONS === "true") return true;
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}
